import { render, staticRenderFns } from "./shipin.vue?vue&type=template&id=70983805&scoped=true&"
import script from "./shipin.vue?vue&type=script&lang=js&"
export * from "./shipin.vue?vue&type=script&lang=js&"
import style0 from "./shipin.vue?vue&type=style&index=0&id=70983805&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70983805",
  null
  
)

export default component.exports